import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';
import languageReducer from './languageReducer';
import accountReducer from './accountReducer';
import modalReducer from './modalReducer'


const rootReducer = combineReducers({
  language: languageReducer,
  account: accountReducer,
  form: formReducer,
  modal: modalReducer,
})

export type AppState = ReturnType<typeof rootReducer>;
export default rootReducer;
